/**
 * Builds a URL path for navigating to a feature with optional hierarchyId
 * Pattern: /:featureName/hierarchyId/:hierarchyId or /:featureName
 *
 * @param featureName - The name of the feature to navigate to
 * @param hierarchyId - Optional hierarchyId to include in the path
 * @returns The constructed URL path
 */
export const buildFeatureUrl = (featureName: string, hierarchyId?: string | null): string => {
  if (hierarchyId) {
    return `/${featureName}/hierarchyId/${hierarchyId}`
  }
  return `/${featureName}`
}

/**
 * Router state the Suite hierarchy picker navigates with. The picker swaps only the `hierarchyId`
 * segment of a feature URL, so features whose sub-path belongs to the previous node can detect
 * the switch by this state and restart at their root.
 */
export const HIERARCHY_PICKER_CHANGE_STATE = {hierarchyChangedBy: 'picker'} as const
